import type { FC } from 'react';
import { BlogContentRenderer } from '@/components/Blog/BlogComponents';
import type { CaseStudy } from '@/data/caseStudies/types';

interface CaseStudyContentSectionProps {
  caseStudy: CaseStudy;
}

const CaseStudyContentSection: FC<CaseStudyContentSectionProps> = ({ caseStudy }) => {
  const { title, content = [] } = caseStudy;

  if (content.length === 0) {
    return null;
  }

  return (
    <section className="w-full font-montreal text-zinc-800 dark:text-white/85">
      <BlogContentRenderer content={content} postTitle={title} variant="caseStudy" />
    </section>
  );
};

export default CaseStudyContentSection;
